export default "__VITE_ASSET__ea9a9144__"